"use strict";
/**
 * File access policy helpers (CR-011)
 *
 * マルウェアスキャン状態に基づくダウンロード可否判定を一元化する。
 * 共有経由ダウンロード（download-share-file / download-share-all）はこの関数で
 * ゲートし、判定のドリフト（ハンドラ間の不整合）を防ぐ。
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFileDownloadable = isFileDownloadable;
/**
 * ファイルがダウンロード可能かを判定する（fail-closed）。
 *
 * マルウェアスキャンが完了し `clean` と判定されたファイルのみ許可する：
 *   - Status='active' かつ ScanResult='clean' → true
 *   - infected / scanning / pending / expired / deleted → false
 *   - unsupported / scan_failed（スキャン未完了・不能）→ false（fail-closed）
 *
 * アップロード上限を GuardDuty Malware Protection for S3 のスキャン上限(5GB)に
 * 合わせているため、サイズ起因の unsupported は原則発生しない。スキャン完了で
 * active へ遷移する際は必ず ScanResult が設定される（pending→scanning→active）。
 */
function isFileDownloadable(file) {
    return file.Status === 'active' && file.ScanResult === 'clean';
}
//# sourceMappingURL=file-access.js.map